import React, { useEffect, useState } from 'react';
import InputForm from '../../../../InputT';
import SearInputM from '../../../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';

import DataType from '../../../../../Types/DataTablePiclist';
import Datas from '../../../../../Data/Data.json'
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import SweetAlert from "sweetalert2"
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';

let searchOperat  : Params = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

function Tab2(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser();

  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
              <Grid item xs={12} md={12}  lg={12} >
                <SelectMultipleOptionPanier notRequired disabled form={props.form}  Size="large"  width={4}  label="Frais de gestion"  name="CodeFrais"  Parametre={searchOperat} />
              </Grid>
            </Box>
      </div>
    </div>
  )
}

export default Tab2;  
